// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"3d14bec1","41":"e11df1fc","80":"e5b4c873","443":"70ba21d1","453":"f810875b"}[chunkId] + ".chunk.js";
};